<template>
  <div class="cnc-radio-button-group" :class="`${sizeRadio[size]} ${disabled ? 'is-disabled' : ''}`">
    <div class="fragment-head">
      <div v-if="title" class="txt-title">{{ title }}</div>
      <div v-if="rightIcon && rightIcon.name">
        <SvgIcon v-if="rightIcon.type === 'svg'" :name="rightIcon.name" />
        <Icon v-else :name="rightIcon.name" />
      </div>
    </div>
    <div v-if="desc" class="txt-radio-desc">{{ desc }}</div>
    <el-radio-group v-model="selectedValue" :disabled="disabled">
      <CncRadioButton :class="orientationClasses" :choices="choices" :size="size" :disabled="disabled" :isError="isError" />
    </el-radio-group>
    <div v-if="isError" class="txt-radio-error">{{ errMessage }}</div>
  </div>
</template>

<script>
export default {
  components: {
    Icon: () => import('./Icon.vue'),
  },
  props: {
    value: { type: Boolean },
    rightIcon: { type: Object },
    size: { type: String, default: 'medium' },
    selected: { type: String },
    orientation: { type: String, default: 'horizontal' },
    choices: { type: Array, default: () => [] },
    title: { type: String },
    desc: { type: String },
    errMessage: { type: String },
    disabled: { type: Boolean, default: false },
    isError: { type: Boolean }
  },
  data () {
    return {
      val: this.value,
      sizeRadio: {
        'medium': 'medium',
        'small': 'small'
      },
      selectedValue: this.selected
    }
  },
  computed: {
    orientationClasses () {
      return this.orientation === 'horizontal' ? 'horizontal' : 'vertical'
    }
  },
  watch: {
    value (val, oldVal) {
      this.val = val
    },
    val (val) {
      this.$emit("update:value", val)
    },
  },
}
</script>

<style lang="scss">
.cnc-radio-button-group {
  display: flex;
  flex-direction: column;

  .el-radio {
    margin-right: 0px;
  }

  .fragment-head {
    display: flex;
    align-items: center;
    gap: $spacing-3xs;
    flex-wrap: wrap;

    i {
      color: $color-cool-grey-500;
      font-size: 20px;
    }

    .txt-title {
      color: $color-cool-grey-900;
      white-space: normal;
      word-wrap: break-word;
      max-width: 250px;
    }

    .text-required {
      color: $color-primary-500;
      padding-left: 4px;
    }
  }

  .txt-radio-desc {
    color: $color-cool-grey-500;
    cursor: default;
    white-space: normal;
    word-wrap: break-word;
    max-width: 250px;
  }

  .cnc-radio-button.horizontal {
    display: flex;
    flex-direction: row;
    gap: $spacing-xl;
    flex-wrap: wrap;
    row-gap: $spacing-sm;
    padding: $spacing-xs 0px $spacing-xs 0px;
  }

  .cnc-radio-button.vertical {
    display: flex;
    flex-direction: column;
    gap: $spacing-sm;
    padding: $spacing-sm 0px $spacing-sm 0px;
  }

  .txt-radio-error {
    color: $color-semanticRed-500;
    cursor: default;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  &.is-disabled {

    .fragment-head .txt-title {
      color: $color-cool-grey-300;
    }

    .txt-radio-desc {
      color: $color-cool-grey-300;
    }
  }

  &.medium {
    .txt-title {
      font: $font-style-title-md-med;
    }

    .txt-radio-desc {
      font: $font-style-title-md-reg;
    }

    .txt-radio-error {
      font: $font-style-body-md-reg;
    }
  }

  &.small {
    .txt-title {
      font: $font-style-title-sm-med;
    }

    .txt-radio-desc {
      font: $font-style-title-sm-reg;
    }

    .txt-radio-error {
      font: $font-style-body-sm-reg;
    }

    .fragment-head i {
      font-size: 14px;
    }

    .cnc-radio-button.horizontal {
      gap: $spacing-md;
      row-gap: $spacing-xs;
    }

    .cnc-radio-button.vertical {
      gap: $spacing-xs;
    }
  }
}
</style>
